module.exports = __webpack_public_path__ + "static/media/privacy.88cbe6ce.md";